import React from 'react';
import './DeliveryDetail.css';

// Import your new images
import webAppImg from '../../assets/images/delivery-detail-webapp.png';
import emailImg from '../../assets/images/delivery-detail-email.png';
import apiImg from '../../assets/images/delivery-detail-api.png';
import whatsappImg from '../../assets/images/delivery-detail-whatsapp.png';

const deliveryDetailsData = [
  {
    image: webAppImg,
    title: 'Website & Mobile App',
    description: 'Access your dashboards, market updates, and reports from anywhere. Our responsive web and mobile platforms ensure a smooth, intuitive experience whether you’re at your desk or on the move.'
  },
  {
    image: emailImg,
    title: 'Email',
    description: 'Get curated insights, pricing updates, and reports directly into your inbox. Timely, relevant, and structured to support your daily decision-making needs.'
  },
  {
    image: apiImg,
    title: 'API Integration',
    description: 'Plug CRISHI data directly into your internal systems, ERPs, or models. Our API allows for real-time access to price feeds, assessments, and custom data points, all in a secure, scalable format.'
  },
  {
    image: whatsappImg,
    title: 'WhatsApp',
    description: 'Stay updated on the go with WhatsApp channel. Receive pricing updates, reports, or insights wherever business takes you.'
  }
];

const DeliveryDetail = () => {
  return (
    <section className="delivery-detail-section">
      <div className="delivery-detail-container">
        <div className="section-header">
          <h2>Delivery modes</h2>
          <div className="header-line"></div>
        </div>
        <p className="section-subtitle">
          Easy access to crucial information when you need it, where you need it.
        </p>

        <div className="delivery-detail-list">
          {deliveryDetailsData.map((item, index) => (
            <div key={index} className="delivery-detail-item">
              <div className="delivery-detail-image">
                {/* --- THIS IS THE FIX --- */}
                {/* The img tag is now INSIDE the circle div */}
                <div className="image-circle-bg">
                  <img src={item.image} alt={item.title} />
                </div>
              </div>
              <div className="delivery-detail-text">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DeliveryDetail;